import { render, staticRenderFns } from "./FontAwesomeGlyphPicker.vue?vue&type=template&id=8b858942&scoped=true"
import script from "./FontAwesomeGlyphPicker.vue?vue&type=script&lang=js"
export * from "./FontAwesomeGlyphPicker.vue?vue&type=script&lang=js"
import style0 from "./FontAwesomeGlyphPicker.vue?vue&type=style&index=0&id=8b858942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b858942",
  null
  
)

export default component.exports